<div fxLayout="column" fxLayoutAlign="center center" class="loader-container">
  <div class="loader">Loading...</div>
</div>
